module.exports = function (data) {
    return {
        event: 'BWSAUregistrationSuccess',
        eventContext: {
            subType: 'registrationSuccess',
            registrationType: 'Email',
            subscription: data.selectNewsLetter ? 'true' : 'false',
            woolworthsRewards: data.HasEdrCard ? 'true' : 'false',
            eventID: data.eventID
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/registration-success.js
 **/